import {Fragment} from "react";

import {Footer} from "../../navigation/components/Footer";
import {Navigation} from "../../navigation/components/Navigation";
import {GoneView} from "./GoneView";

export const GoneLayout = () => {
    return (
        <Fragment>
            <Navigation />
            <GoneView />
            <Footer />
        </Fragment>
    );
};
import {Fragment} from "react";

import {Footer} from "../../navigation/components/Footer";
import {Navigation} from "../../navigation/components/Navigation";
import {GoneView} from "./GoneView";

export const GoneLayout = () => {
    return (
        <Fragment>
            <Navigation />
            <GoneView />
            <Footer />
        </Fragment>
    );
};
